import * as React from 'react';
// tslint:disable-next-line:ordered-imports
import { ProjectLinkModel, ProjectModel, ServiceModel, UspModel } from '../../../../models'
import Controller, { IAbstractDashboardControllerProps } from '../../common/CommonDashboardController';
import View from './ProjectAddEditView';

interface IProjectAddEditViewControllerState extends Interfaces.IViewControllerState {
    project: ProjectModel
    isNextStepAfterProjectCreationDialogOpen: boolean
    uspSearchResult: UspModel[]
    servicesSearchResult: ServiceModel[]
    projectTypesSearchResult: ProjectLinkModel.Model[]
}

class ProjectAddEditViewController<P, S> extends Controller<P, S & IProjectAddEditViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Создание проекта'
    }

    constructor(props: any) {
        super(props)
        this.state = {
            logicError: '',
            project: new ProjectModel(),
            isNextStepAfterProjectCreationDialogOpen: false,
            uspSearchResult: [],
            servicesSearchResult: [],
            projectTypesSearchResult: [],
        } as any;
    }

    public goBack() {
        const { project } = this.state;
        project.usp = project.usp && project.usp.value ? project.usp.value : project.usp;
        project.types = project.types.map((b: any) => {
            return b ? b.value : b
        })
        project.services = project.services.map((s: any) => {
            return s ? s.value : s
        })
        super.goBack();
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true });
        const projectId = this.props.history['location']['state'] ? this.props.history['location']['state']['projectId'] : null;
        let project = this.state.project;
        const backedProject = this.props.history['location']['state'] ? this.props.history['location']['state']['project'] : null;
        if (backedProject && backedProject instanceof ProjectModel) {
            project = backedProject;
        }
        if (projectId) {
            project = await ProjectModel.loadProject(projectId);
            project.usp = project.usp ? { label: project.usp.name, value: project.usp } : null
            project.types = project.types.length ? project.types.map((t: any) => {
                return { label: t.name, value: t }
            }) : []
            project.services = project.services.length ? project.services.map((s: any) => {
                return { label: s.title.ru, value: s }
            }) : []
        }
        this.setState({ project, loading: false });
    }

    public onCreateContent(t: string) {
        this.props.history['replace'](`/${t}/add`, { project: this.state.project })
    }

    public async onSearchContent(s: string, t: string) {
        const { project } = this.state;
        switch (t) {
            case 'Usp':
                let usps = await UspModel.searchUsp(s, 10000, 0)
                if (project.usp) {
                    usps = usps['filter']((u: any) => u.id !== project.usp.value.id);
                }
                this.setState({ uspSearchResult: s ? usps as UspModel[] : [] });
                break;
            case 'Services':
                let services = await ServiceModel.searchService(s, 10000, 0) as ServiceModel[];
                if (project.services.length) {
                    services = services.filter((sb: ServiceModel) => {
                        return !project.services.some((b: any) => {
                            if (b.value){
                                return sb.id === b.value.id
                            } else {
                                return false
                            }
                        })
                    });
                }
                this.setState({ servicesSearchResult: s ? services : [] });
                break;
            default:
                let projectLinks = await ProjectLinkModel.Model.searchProjectLink(s, 10000, 0);
                if (project.types.length) {
                    projectLinks = projectLinks['filter']((sb: ProjectLinkModel.Model) => {
                        return !project.types.some((b: any) => {
                            return sb.id === b.value.id
                        })
                    });
                }
                this.setState({ projectTypesSearchResult: s ? projectLinks as ProjectLinkModel.Model[] : [] });
                break;
        }
    }

    public onAnotherPost() {
        this.setState({ project: new ProjectModel(), isNextStepAfterProjectCreationDialogOpen: false })
    }


    public async onProjectSave() {
        const { project } = this.state;
        this.setState({ loading: true });
        // project.usp = project.usp.value ? project.usp.value : project.usp;
        project.services = project.services.map((s: any) => {
            return s.value ? s.value : s
        })
        project.types = project.types.map((b: any) => {
            return b.value ? b.value : b
        })
        await project.saveFullProject()
        // project.usp = { label: project.usp.name, value: project.usp }
        project.types = project.types.map((b: any) => {
            return { label: b.name, value: b }
        })
        project.services = project.services.map((s: any) => {
            return { label: s['title']['ru'], value: s }
        })
        this.setState({ loading: false, project, isNextStepAfterProjectCreationDialogOpen: true });
    }

    public onCloseDialog() {
        this.setState({ project: this.state.project, isNextStepAfterProjectCreationDialogOpen: false });
    }

    public dashboard_render(): JSX.Element {
        const { project, loading, isNextStepAfterProjectCreationDialogOpen, projectTypesSearchResult, uspSearchResult, servicesSearchResult } = this.state;
        return <View
            accessAvailable={this.accessAvailable}
            onAnotherCreation={() => this.onAnotherPost()}
            onSearchContent={(s: string, t: string) => this.onSearchContent(s, t)}
            model={project}
            servicesSearchResult={servicesSearchResult}
            loading={loading}
            onSave={() => this.onProjectSave()}
            isNextStepAfterCreationDialogOpen={isNextStepAfterProjectCreationDialogOpen}
            onCreateContent={(t: string) => this.onCreateContent(t)}
            uspSearchResult={uspSearchResult}
            projectTypesSearchResult={projectTypesSearchResult}
            // tslint:disable-next-line:jsx-no-lambda
            onBack={() => this.goBack()}
            onDialogClose={() => this.onCloseDialog()}
        />
    }
}

export default ProjectAddEditViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/project/addedit/ProjectAddEditViewController.tsx